import {
  collection,
  doc,
  getDocs,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  serverTimestamp
} from 'firebase/firestore';
import { db } from '../firebase';

const GUIDES_COLLECTION = 'courseGuides';

// Get all course guides
export async function getAllCourseGuides() {
  const guidesRef = collection(db, GUIDES_COLLECTION);
  const snapshot = await getDocs(guidesRef);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
}

// Get guides for a specific course
export async function getGuidesByCourseId(courseId) {
  const guidesRef = collection(db, GUIDES_COLLECTION);
  const q = query(guidesRef, where('course_id', '==', courseId));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
}

// Add new course guide
export async function addCourseGuide({ courseId, courseName, guide, link }) {
  const guidesRef = collection(db, GUIDES_COLLECTION);
  const newGuide = {
    course_id: courseId,
    'course name': courseName,
    guide: guide,
    link: link,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  };
  const docRef = await addDoc(guidesRef, newGuide);
  return { id: docRef.id, ...newGuide };
}

// Update existing course guide
export async function updateCourseGuide(guideId, { guide, link }) {
  const guideRef = doc(db, GUIDES_COLLECTION, guideId);
  const updates = {
    guide: guide,
    link: link,
    updatedAt: serverTimestamp()
  };
  await updateDoc(guideRef, updates);
  return { id: guideId, ...updates };
}

// Delete course guide
export async function deleteCourseGuide(guideId) {
  const guideRef = doc(db, GUIDES_COLLECTION, guideId);
  await deleteDoc(guideRef);
  return guideId;
}

// Get unique guide names (for dropdown)
export async function getUniqueGuideNames() {
  const guides = await getAllCourseGuides();
  const uniqueNames = [...new Set(guides.map(g => g.guide))];
  return uniqueNames.sort();
}
